export default __webpack_public_path__ + "static/media/snorlax-gif.635908eb.gif";